import API from "./api";

const adminApi = {
  getDashboard: () => API.get("/admin/dashboard"),
  getUsers: (params) => API.get("/admin/users", { params }),
  updateUser: (id, payload) => API.patch(`/admin/users/${id}`, payload),
  uploadQuestionImage: (formData) => API.post("/admin/question-image", formData),
  deleteQuestionImage: (publicId) => API.delete("/admin/question-image", { data: { publicId } }),
  getQuizzes: (params) => API.get("/admin/quizzes", { params }),
  createQuiz: (payload) => API.post("/admin/quizzes", payload),
  updateQuiz: (id, payload) => API.put(`/admin/quizzes/${id}`, payload),
  archiveQuiz: (id) => API.patch(`/admin/quizzes/${id}/archive`),
  cloneQuiz: (id) => API.post(`/admin/quizzes/${id}/clone`),
  createQuizVersion: (id) => API.post(`/admin/quizzes/${id}/new-version`),
  deleteQuiz: (id) => API.delete(`/admin/quizzes/${id}`),
  getResults: (params) => API.get("/admin/results", { params }),
};

export default adminApi;
